module.exports = __webpack_public_path__ + "img/table_2.dcc71a43.png";